import { GameWinLineProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameWinLineProperties";
export class WinLineLandscapeProperties extends GameWinLineProperties {
    constructor() {
        super();
        this.position.set(629, 888);
    }
}
//# sourceMappingURL=WinLineLandscapeProperties.js.map